import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import ChangeUsernameModal from './forum/components/ChangeUsernameModal';
import UsernameHistoryPage from './forum/components/UsernameHistoryPage';

app.initializers.add('happydigital-username-history', () => {
  // ── 1. Register route: /u/:username/username-history ──────────────────────
  app.routes['user.username-history'] = {
    path: '/u/:username/username-history',
    component: UsernameHistoryPage,
  };

  // ── 2. Add tab link to user profile nav ───────────────────────────────────
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user) return;

    const history = user.attribute('usernameHistory');
    if (!history || history.length === 0) return;

    items.add(
      'usernameHistory',
      <LinkButton
        href={app.route('user.username-history', { username: user.slug() })}
        icon="fas fa-history"
      >
        {app.translator.trans('happydigital-username-history.forum.tab_label')}
      </LinkButton>,
      -10
    );
  });

  // ── 3. Add "Change Username" section to Settings page ─────────────────────
  extend(SettingsPage.prototype, 'accountItems', function (items) {
    if (!app.session.user) return;
    if (!app.session.user.attribute('canChangeUsername')) return;

    items.add(
      'changeUsername',
      <div className="Form-group HappyDigital-changeUsername">
        <label>
          {app.translator.trans('happydigital-username-history.forum.change_username_label')}
        </label>
        <p className="helpText">
          {app.translator.trans('happydigital-username-history.forum.change_username_help')}
        </p>
        <Button
          className="Button"
          onclick={() => app.modal.show(ChangeUsernameModal)}
        >
          <i className="fas fa-user-edit Button-icon" />
          {app.translator.trans('happydigital-username-history.forum.change_username_button')}
        </Button>
      </div>,
      100
    );
  });
});
